/* ============================================================================
   Das Element IST die Section-Wurzel (`.customizable-product-section`).
   Alles, was der Konfigurator anfasst, liegt darin. Gesucht wird deshalb nur
   unterhalb von `this`.

   DATEN kommen aus `<script type="application/json" data-konfigurator>` im
   Element (Teile, Varianten, Preise, Ebenenbilder je Ansicht).

   SCHNITTSTELLEN NACH AUSSEN:
     window.CustomizableATC()            Kauf ausloesen. Rufen
                                         snippets/product-bundles.liquid
                                         (Popup-Kaufknopf) und
                                         snippets/product-app-accessories.liquid.
     customizable:variant-updated        an diesem Element, { available,
                                         totalPrice, formattedPrice }
     customizable:srcs-updated           { srcs } — Ebenen der Ansicht 1, _40x
     customizable:added-to-cart          nach erfolgreichem Kauf
     nko:cart:add                        am document, oeffnet die Schublade
   Gelesen werden: theme.Currency (money.js), theme.settings.moneyFormat,
   theme.popupApp (popup.js), Shopify.refreshLoyaltyPoints
   (snippets/scripts.liquid), <accessories-component>, <bundles-component>.
   ==========================================================================  */

/* DOMContentLoaded AUCH NACHTRAEGLICH. Die URL-Konfiguration klickt Radios,
   und jeder Klick rechnet den Preis mit `theme.Currency` aus money.js —
   einem Modul, das im Dokument NACH diesem steht und darum erst nach ihm
   laeuft. `Shopify.refreshLoyaltyPoints` entsteht erst in einem
   DOMContentLoaded-Hoerer (snippets/scripts.liquid), der frueher angemeldet
   ist als dieser. Also auf DOMContentLoaded warten — ausser das
   Ereignis ist schon vorbei (Section im Theme-Editor neu gerendert): Die
   Navigation-Timing-Angabe ist 0, solange es nicht gefeuert hat; der
   readyState hilft hier nicht, er steht vorher wie nachher auf
   "interactive". */
function onDomReady(fn, signal) {
  const nav = performance.getEntriesByType("navigation")[0];
  if (nav && nav.domContentLoadedEventStart > 0) {
    fn();
    return;
  }
  document.addEventListener("DOMContentLoaded", fn, { once: true, signal });
}

class NkoConfigurator extends HTMLElement {
  connectedCallback() {
    const source = this.querySelector("script[data-configurator]");
    if (!source) return;
    let data;
    try {
      data = JSON.parse(source.textContent);
    } catch (error) {
      return;
    }
    this.ac = new AbortController();
    this.teardown = init(this, data, this.ac.signal);
  }

  disconnectedCallback() {
    this.ac?.abort();
    this.teardown?.();
    this.teardown = null;
  }
}

function init(section, data, signal) {
  const sectionId = data.sectionId;
  const partsData = data.parts;
  const $ = (sel) => section.querySelector(sel);
  const $$ = (sel) => section.querySelectorAll(sel);
  const on = (el, typ, fn) => el?.addEventListener(typ, fn, { signal });

  const formsToggle = $("#ToggleForms-" + sectionId);
  const formsContainer = $("#Forms-" + sectionId);
  const frameForm = $("#AddToCartForm-" + partsData.frame.id);
  const lensForm = $("#AddToCartForm-" + partsData.lens.id);
  const jawForm = partsData.jaw && $("#AddToCartForm-" + partsData.jaw.id);
  const atcBtn = $("#AddToCart-" + sectionId);
  const minicartSection = $(".section--minicart");
  const atcMiniBtn = $("#AddToCartMinicart-" + sectionId);
  const backInStockBtn = $("#BackInStock-" + sectionId);
  const backInStockContainer = $("#BackInStockContainer-" + sectionId);
  const jawToggle = partsData.jaw && $("#jaw-enable-checkbox");
  const combosForm = $("#combos");
  const comboRadios = $$("#combos input[type=radio]");
  const formTabButtons = $$(".customizable-tabs button");
  const allFormRadios = $$("[id^=AddToCartForm-] input[type=radio]");
  const allForms = $$("[id^=AddToCartForm-]");
  const previewLoader = $(".preview-loader");
  const previewContainer = $("#preview-container");
  const previewContainer1 = $("#preview-container-side-1");
  const previewContainer2 = $("#preview-container-side-2");
  const previewContainer3 = $("#preview-container-side-3");
  const previewContainer4 = $("#preview-container-side-4");
  const previewModal = $("#preview-modal");
  const previewModalImgContainer = $("#preview-modal-img-container");
  const warnPopup = $(".customizable-popup-warn");
  const warnPopupCancelButton = $("#customizable-popup-warn-cancel");
  const warnPopupConfirmButton = $("#customizable-popup-warn-confirm");
  const warnPopupOverlay = $(".customizable-popup-warn-overlay");
  const lensCategoryWidgets = $$(
    "#LensCategory-" +
      sectionId +
      "-preview, #LensCategory-" +
      sectionId +
      "-form",
  );

  const LAYERS_COUNT = partsData.jaw ? 3 : 2;

  allFormRadios.forEach((radio) => on(radio, "click", onVariantChange));
  formTabButtons.forEach((btn) => on(btn, "click", onTabChange));
  on(jawToggle, "click", onJawToggle);
  on(jawToggle, "change", onJawToggleChange);
  comboRadios.forEach((radio) => on(radio, "click", onComboChange));
  on(formsToggle, "click", onFormsToggle);
  on(atcBtn, "click", onAtcClick);
  on(atcMiniBtn, "click", onAtcClick);
  on(backInStockBtn, "click", onBackInStockClick);
  // URL-Konfiguration (?frame=&lens=&jaw= bzw. ?variant=), siehe nachDomBereit
  onDomReady(setVariantsFromParams, signal);
  on(previewContainer1, "click", changeThumb);
  on(previewContainer2, "click", changeThumb);
  on(previewContainer3, "click", changeThumb);
  on(previewContainer4, "click", changeThumb);
  on(previewContainer, "click", openModal);
  on(previewContainer, "swipe", (e) => onSwipe(e.detail.deltaX));
  on($("#preview-modal .close-btn"), "click", closeModal);
  on($("#preview-modal .prev-btn"), "click", () => paginateModal(-1));
  on($("#preview-modal .next-btn"), "click", () => paginateModal(1));
  // Wischen im Vollbild: wie in der Vorschau nach links zur naechsten Ansicht
  on(previewModal, "swipe", (e) => {
    if (Math.abs(e.detail.deltaX) >= 100)
      paginateModal(e.detail.deltaX < 0 ? 1 : -1);
  });
  on(warnPopupConfirmButton, "click", onConfirmWarnPopup);
  on(warnPopupCancelButton, "click", hideWarnPopup);
  on(warnPopupOverlay, "click", hideWarnPopup);

  /* Die einzige Globale: Bundles- und Zubehoer-Popup loesen darueber den
     Kauf der ganzen Brille aus. */
  window.CustomizableATC = addToCart;

  /* KAUFLEISTE. assets/sticky-bar.js setzt `body.js-fixed-header` ab
     200px; auf dieser Vorlage blendet section-customizable-product-info.css
     die Leiste darunter trotzdem aus und erst mit `.mini-show` ein — also
     erst, wenn der Kaufknopf oben aus dem Bild ist.
     „Aus dem Bild“ heisst: unter dem stehenden Kopf verschwunden. Deshalb
     ist der Beobachtungsbereich oben um DESSEN Hoehe gekuerzt (Handy 89px,
     ab 1200px 123px). */
  const header = document.querySelector(".header");
  const headerHeight = header
    ? Math.round(header.getBoundingClientRect().height)
    : 0;
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        minicartSection.classList.toggle("mini-show", !entry.isIntersecting);
      });
    },
    { root: null, threshold: 0, rootMargin: `-${headerHeight}px 0px 0px 0px` },
  );
  observer.observe(atcBtn);

  setupPreviewSwipe(previewContainer);
  setupPreviewSwipe(previewModal);

  function setVariantsFromParams() {
    const urlParams = new URLSearchParams(document.location.search);
    const paramVariantIds = {
      frame: urlParams.get("frame"),
      lens: urlParams.get("lens"),
      jaw: urlParams.get("jaw"),
    };
    if (
      paramVariantIds.frame &&
      paramVariantIds.lens &&
      (paramVariantIds.jaw || !partsData.jaw)
    ) {
      frameForm
        .querySelector('input[data-variant-id="' + paramVariantIds.frame + '"]')
        .click();
      lensForm
        .querySelector('input[data-variant-id="' + paramVariantIds.lens + '"]')
        .click();
      jawForm
        ?.querySelector('input[data-variant-id="' + paramVariantIds.jaw + '"]')
        .click();
    } else if (urlParams.has("variant")) {
      /* Die Section rendert die Kombination aus ?variant= schon selbst
         (sections/customizable-product-info.liquid). Der Klick bleibt fuer
         den Fall, dass sie es nicht getan hat; auf die bereits gewaehlte
         wuerde er nur dieselben Ebenen neu laden (Vorschau blinkt). Ohne
         Punkt — Kombination versteckt oder unvollstaendig — bleibt die
         Vorauswahl der Section. */
      const combo = combosForm.querySelector(
        'input[data-variant-id="' + urlParams.get("variant") + '"]',
      );
      if (combo && !combo.checked) combo.click();
    }
    setProductType();
  }

  function onVariantChange() {
    updateProductFormInfo();
    selectMatchingCombo();
    updateImagePreview();
    setProductType();
    updateVariantBadge();
  }

  function selectMatchingCombo() {
    const checkedRadios = formsContainer.querySelectorAll(
      "input[type=radio]:checked",
    );
    const selectedVariantIdsStr = Array.from(checkedRadios)
      .map((radio) => radio.value)
      .join(",");
    const isJawEnabledInToggle = Boolean(jawToggle?.checked);
    let foundCorrespondingCombo = false;
    comboRadios.forEach((radio) => {
      if (!radio.value) return;
      const idsMatch = radio.value === selectedVariantIdsStr;
      const comboJawVariantId = radio.value.split(",")[2];

      let isJawStateMatch = true;
      if (partsData.jaw) {
        const isJawEnabledInCombo =
          partsData.jaw.variants[Number(comboJawVariantId)].title !== "None";
        isJawStateMatch = isJawEnabledInCombo === isJawEnabledInToggle;
      }

      if (idsMatch && isJawStateMatch) {
        radio.checked = true;
        foundCorrespondingCombo = radio.dataset.variantId;
      }
    });
    const url = new URL(window.location.href);
    if (!foundCorrespondingCombo) {
      $("#ComboRadios-None").checked = true;
      url.searchParams.delete("variant");
    } else {
      url.searchParams.set("variant", foundCorrespondingCombo);
    }
    window.history.replaceState({}, "", url.toString());
  }

  function updateProductFormInfo() {
    let totalPrice = 0;
    let hasUnavailablePart = false;
    const variantTitles = { frame: "", lens: "", jaw: "" };

    allForms.forEach((form) => {
      form.querySelectorAll("input[type=radio]").forEach((radio) => {
        if (!radio.checked) return;
        const variantId = radio.value;
        const partHandle = form.dataset.partHandle;
        const variant = partsData[partHandle].variants[variantId];
        if (!radio.disabled) totalPrice += variant.price;
        if (radio.classList.contains("disabled")) hasUnavailablePart = true;
        variantTitles[partHandle] = variant.title;
      });
    });

    const formattedPrice = window.theme.Currency.formatMoney(
      totalPrice,
      theme.settings.moneyFormat,
    );
    $("#ProductPrice-" + sectionId).innerText = formattedPrice;

    // `disabled` heisst hier AUSVERKAUFT: das Blatt blendet den Knopf dann
    // aus und zeigt den Hinweis samt „Benachrichtige mich“. Den laufenden
    // Kauf zeigt deshalb `aria-busy` an (siehe mitKaufsperre).
    atcBtn.disabled = hasUnavailablePart;
    atcMiniBtn.disabled = hasUnavailablePart;

    // Jaw abgewaehlt: dessen Variante heisst "None" (Vertrag, siehe Kopf der
    // Section) — in der Titelzeile ein Strich statt des englischen Worts,
    // wie in snippets/customizable-part-form.liquid.
    allForms.forEach((form) => {
      const title = variantTitles[form.dataset.partHandle];
      form.querySelector(".group__titleValue").innerText =
        title === "None" ? "–" : title;
    });

    if (partsData.jaw) {
      const jawNoneRadio = jawForm.querySelector(
        "input[type=radio].none-variant",
      );
      jawToggle.checked = !jawNoneRadio.checked;
      jawToggle.dispatchEvent(new Event("change"));
    }

    updateMinicart(
      Object.values(variantTitles)
        .filter((title) => title !== "None")
        .filter(Boolean)
        .join(", "),
      formattedPrice,
    );

    window.Shopify?.refreshLoyaltyPoints?.(totalPrice);

    section.dispatchEvent(
      new CustomEvent("customizable:variant-updated", {
        detail: { available: !hasUnavailablePart, totalPrice, formattedPrice },
      }),
    );
  }

  /* Bild-URL der Ebene `layer` in Ansicht `side`: die erste Teil-Variante,
     die fuer diese Ebene ein Bild hat. `size` haengt Shopifys Groessen-
     Suffix an die Original-URL (…/NAME.png → …/NAME_1000x.png). */
  function getImages(variantIds, side, size = null) {
    const partHandles = Object.keys(partsData);
    const layerImgUrls = [];
    for (let layer = 1; layer <= LAYERS_COUNT; layer++) {
      let layerImgUrl;
      for (let i = 0; i < LAYERS_COUNT; i++) {
        const url =
          partsData[partHandles[i]].variants[variantIds[i]].images.sides[
            String(side)
          ].layers[String(layer)];
        if (url) {
          layerImgUrl = !size ? url : url.replace(".png", "_" + size + "x.png");
          break;
        }
      }
      layerImgUrls.push(layerImgUrl);
    }
    return layerImgUrls;
  }

  function getSelectedVariantIds() {
    return Array.from(allForms).map(
      (form) =>
        Array.from(form.querySelectorAll("input[type=radio]")).find(
          (radio) => radio.checked,
        ).value,
    );
  }

  function updateImagePreview() {
    previewContainer.classList.add("opaque");
    previewLoader.classList.add("show");

    const thumbContainers = [
      previewContainer1,
      previewContainer2,
      previewContainer3,
      previewContainer4,
    ];
    const imgEls = [];
    const srcSets = [];
    const srcs = [];
    // fuer <bundles-component>: die Ebenen der Ansicht 1 als Vorschaubild
    const bundleSrcs = [];

    const selectedVariantIds = getSelectedVariantIds();
    for (let side = 1; side <= 4; side++) {
      const sideImages = getImages(selectedVariantIds, side);
      for (let layerIndex = 0; layerIndex < LAYERS_COUNT; layerIndex++) {
        const layerImage = sideImages[layerIndex];
        imgEls.push(
          thumbContainers[side - 1].querySelector(
            "[data-layer='" + String(layerIndex + 1) + "']",
          ),
        );
        srcSets.push(getThumbSrcset(layerImage, "40"));
        srcs.push(layerImage?.replace(".png", "_40x.png"));
        if (String(side) === previewContainer.dataset.side) {
          imgEls.push(
            previewContainer.querySelector(
              "[data-layer='" + String(layerIndex + 1) + "']",
            ),
          );
          srcSets.push(getMainSrcset(layerImage, "1000"));
          srcs.push(layerImage?.replace(".png", "_1000x.png"));
        }
        if (side === 1)
          bundleSrcs.push(layerImage?.replace(".png", "_40x.png"));
      }
    }

    section.dispatchEvent(
      new CustomEvent("customizable:srcs-updated", {
        detail: { srcs: bundleSrcs },
      }),
    );

    loadImages(imgEls, srcSets, srcs).then(() => {
      previewContainer.classList.remove("opaque");
      previewLoader.classList.remove("show");
    });
  }

  function onTabChange(e) {
    e.preventDefault();
    formsContainer.dataset.current = e.target.dataset.part;
  }

  function onJawToggle() {
    const newJawRadio = jawToggle.checked
      ? jawForm.querySelector("input[type=radio]")
      : jawForm.querySelector("input[type=radio].none-variant");
    newJawRadio.click();
  }

  function onJawToggleChange(e) {
    jawForm.classList.toggle("opaque", !e.target.checked);
  }

  function onComboChange(e) {
    if (!e.target.value) return;
    const variantIds = e.target.value.split(",");
    frameForm
      .querySelector('input[data-variant-id="' + variantIds[0] + '"]')
      .click();
    lensForm
      .querySelector('input[data-variant-id="' + variantIds[1] + '"]')
      .click();
    jawForm
      ?.querySelector('input[data-variant-id="' + variantIds[2] + '"]')
      ?.click();
  }

  function onFormsToggle(e) {
    e.preventDefault();
    const button = e.currentTarget;
    const topBefore = button.getBoundingClientRect().top;
    formsContainer.classList.toggle("show");
    button.classList.toggle("arrow-up");
    const isOpen = formsContainer.classList.contains("show");
    button.children[0].innerText = isOpen
      ? data.translations?.hide_customize_button || "Hide details"
      : data.translations?.customize_button || "Customize";
    button.classList.toggle("btn--plain", isOpen);
    combosForm.classList.toggle("hidden-combos", isOpen);
    /* DER KNOPF BLEIBT UNTER DEM FINGER. Schmal blendet das Blatt die
       Kombi-Reihe UEBER ihm aus und die Formulare UNTER ihm ein. Stand er
       dabei knapp unter der Kopfzeile, verankerte Safari das Scrollen am
       Kaufknopf darunter: Knopf, Reiter und Farbfelder lagen danach oberhalb
       des Bilds, als waere nichts passiert. Die Seite wird um genau den Sprung zurueckgestellt —
       `instant`, weil :root weich scrollt (base.css, Abschnitt 10). */
    const scrollJump = button.getBoundingClientRect().top - topBefore;
    if (scrollJump) window.scrollBy({ top: scrollJump, behavior: "instant" });
  }

  /* srcset der Hauptvorschau: 1000w, 1500w, 2000w, 3000w, 4000w aus der
     Original-URL (Groessen-Suffix vor `.png`). */
  function getMainSrcset(url, initSize) {
    if (!url) return "";
    return [1, 1.5, 2, 3, 4]
      .map((f) => {
        const w = Number(initSize) * f;
        return url.replace(".png", "_" + w + "x.png") + " " + w + "w";
      })
      .join(", ");
  }

  function getThumbSrcset(url, initSize) {
    if (!url) return "";
    return (
      url.replace(".png", "_" + initSize + "x.png") +
      ", " +
      url.replace(".png", "_" + Number(initSize) * 2 + "x.png") +
      " 2x"
    );
  }

  function loadImages(imgEls, srcSets, srcs) {
    // Ohne Ebenenbilder (Produkt noch nicht gepflegt) gibt es nichts zu laden.
    if (![...imgEls].some(Boolean)) return Promise.resolve();
    for (const image of imgEls) {
      image.srcset = "";
      image.src = "";
    }
    let loadedImages = 0;
    return new Promise((resolve) => {
      for (let i = 0; i < imgEls.length; i++) {
        const image = imgEls[i];
        image.onload = function () {
          loadedImages++;
          if (loadedImages === imgEls.length) resolve();
        };
        image.srcset = srcSets[i];
        image.src = srcs[i];
      }
    });
  }

  function changeThumb(e) {
    previewContainer.classList.add("opaque");
    previewLoader.classList.add("show");
    const el = e.currentTarget;
    const thumbSide = Number(el.dataset.side);
    const mainImgEls = previewContainer.querySelectorAll("img");
    const sideImages = getImages(getSelectedVariantIds(), thumbSide);
    const srcs = [];
    const srcSets = [];
    for (let i = 0; i < el.querySelectorAll("img").length; i++) {
      srcSets.push(getMainSrcset(sideImages[i], "1000"));
      srcs.push(sideImages[i]?.replace(".png", "_1000x.png"));
    }

    loadImages(mainImgEls, srcSets, srcs).then(() => {
      Array.from(el.parentElement.children).forEach((containerEl) =>
        containerEl.classList.remove("selected"),
      );
      el.classList.add("selected");
      previewContainer.dataset.side = String(thumbSide);
      previewContainer.classList.remove("opaque");
      previewLoader.classList.remove("show");
    });
  }

  function openModal() {
    const side = Number(previewContainer.dataset.side);
    previewModalImgContainer.dataset.side = String(side);
    previewModalImgContainer.innerHTML = "";

    const newImages = [];
    for (const image of getImages(getSelectedVariantIds(), side)) {
      const newImg = document.createElement("img");
      newImg.srcset = getMainSrcset(image, "1000");
      newImg.src = image?.replace(".png", "_1000x.png");
      previewModalImgContainer.appendChild(newImg);
      newImages.push(newImg);
    }
    previewModal.classList.add("show");
    // Erst jetzt, da das Overlay steht: die Einblend-Animation (zoomIn)
    newImages.forEach((img) => img.classList.add("appear"));
  }

  function closeModal() {
    previewModal.classList.remove("show");
    previewModalImgContainer.innerHTML = "";
    previewModalImgContainer.dataset.side = null;
  }

  // Pfeile im Vollbild: eine Ansicht zurueck (-1) oder vor (+1), rundum
  function paginateModal(direction) {
    previewModalImgContainer.classList.add("opaque");
    setTimeout(() => previewModalImgContainer.classList.remove("opaque"), 100);
    previewModalImgContainer.innerHTML = "";
    const currSide = Number(previewModalImgContainer.dataset.side);
    const nextSide = ((currSide - 1 + direction + 4) % 4) + 1;
    const sideImages = getImages(getSelectedVariantIds(), nextSide);

    const imgEls = [];
    const srcs = [];
    for (let layerIndex = 0; layerIndex < LAYERS_COUNT; layerIndex++) {
      const newImg = document.createElement("img");
      previewModalImgContainer.appendChild(newImg);
      imgEls.push(newImg);
      srcs.push(sideImages[layerIndex]);
    }
    previewModalImgContainer.dataset.side = String(nextSide);
    // srcset und src sind hier bewusst dieselbe Original-URL
    loadImages(imgEls, srcs, srcs);
  }

  function setProductType() {
    const variantId = getSelectedVariantIds()[1];
    const variantTitle = partsData.lens.variants[variantId].title;
    lensCategoryWidgets.forEach((el) => {
      el.dataset.variantTitle = variantTitle;
    });
  }

  function updateVariantBadge() {
    const badge = $(".product__variant-image-badge");
    if (!badge) return;

    const allVariantData = Object.values(partsData)
      .map((v) => v.variants)
      .reduce((a, b) => ({ ...a, ...b }), {});
    let badgeText = "";
    for (const id of getSelectedVariantIds().reverse()) {
      if (allVariantData[id].badges?.[0])
        badgeText = allVariantData[id].badges[0];
    }
    if (badgeText) {
      badge.innerText = badgeText;
      badge.classList.remove("hide");
    } else {
      badge.classList.add("hide");
      badge.innerText = "";
    }
  }

  /* Meldet waagrechtes Wischen auf `flaeche` als Ereignis `swipe` an ihr —
     auf der Vorschau und, damit dort nicht nur die Pfeile blaettern, auf dem
     Vollbild.

     Ein Wischen ist nur EIN Finger auf unvergroesserter Seite. Zwei Finger
     zoomen, und in der vergroesserten Ansicht verschiebt ein Finger den
     Ausschnitt — gerade im Vollbild, wo man sich Details ansieht. Beides
     bleibt dem Browser; ohne die Abfrage hielte `preventDefault` unten es
     auf und die Ansicht spraenge beim Loslassen weiter. */
  function setupPreviewSwipe(surface) {
    let startX;
    let startY;
    let isSwiping = false;
    let singleTouch = false;

    on(surface, "touchstart", (event) => {
      singleTouch =
        event.touches.length === 1 &&
        (window.visualViewport?.scale || 1) < 1.01;
      isSwiping = false;
      startX = event.touches[0].pageX;
      startY = event.touches[0].pageY;
    });
    // Nicht passiv: waagrechtes Wischen darf die Seite nicht mitscrollen.
    on(surface, "touchmove", (event) => {
      if (!singleTouch) return;
      const deltaX = event.touches[0].pageX - startX;
      const deltaY = event.touches[0].pageY - startY;
      if (Math.abs(deltaX) > Math.abs(deltaY)) {
        event.preventDefault();
        isSwiping = true;
      } else {
        isSwiping = false;
      }
    });
    on(surface, "touchend", (event) => {
      if (isSwiping) {
        const deltaX = event.changedTouches[0].pageX - startX;
        surface.dispatchEvent(new CustomEvent("swipe", { detail: { deltaX } }));
      }
      isSwiping = false;
    });
  }

  function onSwipe(deltaX) {
    if (Math.abs(deltaX) < 100) return;
    const currSide = Number(previewContainer.dataset.side);
    const nextSide =
      deltaX < 0
        ? currSide === 4
          ? 1
          : currSide + 1
        : currSide === 1
          ? 4
          : currSide - 1;
    [
      previewContainer1,
      previewContainer2,
      previewContainer3,
      previewContainer4,
    ][nextSide - 1].click();
  }

  /* BENACHRICHTIGEN, WENN WIEDER DA. Holt das Formular als Section
     `customizable-product-notify-stock` und zeigt es im Container. */
  async function closeBackInStock() {
    backInStockContainer.innerHTML = "";
    backInStockContainer.style.display = "none";
  }

  async function handleNotifySubmit(e) {
    e.preventDefault();
    const errorMessage = backInStockContainer.querySelector("#error_message");
    const successMessage =
      backInStockContainer.querySelector("#completed_message");
    const formData = new FormData(e.target);
    try {
      successMessage.style.display = "none";
      errorMessage.style.display = "none";
      const res = await fetch(
        "https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=QP6W8G",
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            revision: "2025-04-15",
          },
          method: "POST",
          body: JSON.stringify({
            data: {
              type: "back-in-stock-subscription",
              attributes: {
                channels: ["EMAIL"],
                profile: {
                  data: {
                    type: "profile",
                    attributes: { email: formData.get("email") },
                  },
                },
              },
              relationships: {
                variant: {
                  data: {
                    type: "catalog-variant",
                    id: `$shopify:::$default:::${formData.get("variant")}`,
                  },
                },
              },
            },
          }),
        },
      );
      if (!res.ok) {
        const data = await res.json();
        errorMessage.style.display = "block";
        errorMessage.innerText =
          data?.errors?.[0]?.detail || "There was an error with your request.";
      } else {
        successMessage.style.display = "block";
        backInStockContainer
          .querySelector(".bis-close")
          ?.addEventListener("click", closeBackInStock, { signal });
      }
    } catch (error) {
      errorMessage.style.display = "block";
      errorMessage.innerText = "There was an error with your request.";
    }
  }

  async function onBackInStockClick() {
    const urlParams = new URLSearchParams(document.location.search);
    const reqParams = new URLSearchParams();
    if (urlParams.has("variant"))
      reqParams.set("variant", urlParams.get("variant"));
    reqParams.set("section_id", "customizable-product-notify-stock");
    const res = await fetch(
      window.location.pathname + "?" + reqParams.toString(),
    ).catch(() => null);
    /* Ohne Section (404, Netzfehler) bleibt der Container zu. */
    if (!res || !res.ok) {
      backInStockContainer.style.display = "none";
      return;
    }
    backInStockContainer.innerHTML = await res.text();
    /* Vorgewaehlt ist das Teil, das der AKTUELLEN Auswahl fehlt. Die Liste
       nennt alle ausverkauften Varianten aller Teile, Rahmen zuerst. Die Section
       kann es nicht wissen: eine freie Mischung steht in keiner Adresse. */
    const missingPart = formsContainer.querySelector(
      "input[type=radio].disabled:checked",
    );
    const partsList = backInStockContainer.querySelector(
      "select[name=variant]",
    );
    if (
      missingPart &&
      partsList?.querySelector('option[value="' + missingPart.value + '"]')
    ) {
      partsList.value = missingPart.value;
    }
    backInStockContainer.style.display = "block";
    backInStockContainer
      .querySelector("form")
      .addEventListener("submit", handleNotifySubmit, { signal });
    backInStockContainer
      .querySelector(".close")
      .addEventListener("click", closeBackInStock, { signal });
    backInStockContainer
      .querySelector("#shopify-section-customizable-product-notify-stock")
      .addEventListener(
        "click",
        function (e) {
          if (e.target === this) closeBackInStock();
        },
        { signal },
      );
  }

  function updateMinicart(variantsTitle, price) {
    $(".minicart .minicart__variant").innerText = variantsTitle;
    $(".minicart .price").innerText = price;
  }

  function showWarnPopup() {
    warnPopup.classList.add("show");
  }

  function hideWarnPopup() {
    warnPopup.classList.remove("show");
  }

  function onConfirmWarnPopup() {
    hideWarnPopup();
    addToCart();
  }

  /* LAUFSPERRE FUER DEN KAUF. Ohne sie legte jeder weitere Klick
     waehrend eines langsamen cart/add.js eine WEITERE komplette Brille in den
     Warenkorb. Die
     Duplikatwarnung half nicht — jede Anfrage bekommt ihre eigene
     `_customizable_group_id`, und die erste war noch nicht angekommen.

     Sie umschliesst auch die Duplikatpruefung (/cart.js), weil der zweite
     Klick sonst waehrend DIESER Anfrage durchkaeme. Alle Wege zum Kauf gehen
     hier durch: Kaufknopf, Minicart, Warn-Popup, Geschenk-Popup und
     window.CustomizableATC (Bundles, Zubehoer).

     Sichtbar wird der Zustand ueber `aria-busy`, NICHT ueber `disabled` —
     das bedeutet auf dieser Seite „ausverkauft“ (siehe
     updateProductFormInfo). Die Gestaltung teilt der Konfigurator mit der
     Produktseite (section-product.css, `.btn--cart[aria-busy]`: Knopf bleibt
     lila, Kreis statt Beschriftung). */
  let purchaseInProgress = false;

  async function withPurchaseLock(step) {
    if (purchaseInProgress) return;
    purchaseInProgress = true;
    atcBtn.setAttribute("aria-busy", "true");
    atcMiniBtn.setAttribute("aria-busy", "true");
    try {
      await step();
    } finally {
      purchaseInProgress = false;
      atcBtn.setAttribute("aria-busy", "false");
      atcMiniBtn.setAttribute("aria-busy", "false");
    }
  }

  function onAtcClick(e) {
    e.preventDefault();
    return withPurchaseLock(async () => {
      if (await hasCartDuplicates()) {
        showWarnPopup();
        return;
      }
      await purchase();
    });
  }

  function addToCart(e) {
    return withPurchaseLock(() => purchase(e));
  }

  /* Liegt schon eine konfigurierte Brille im Warenkorb, die mit der
     aktuellen Auswahl Teile teilt, aber nicht in allen uebereinstimmt?
     Dann erst die Warnung (Versand im Etui, siehe Popup-Text). */
  async function hasCartDuplicates() {
    try {
      const selectedVariantIds = getSelectedVariantIds();
      const data = await (await fetch("/cart.js")).json();
      const existingBundles = {};
      for (const item of data.items) {
        const bundleId = item.properties._customizable_group_id;
        if (!bundleId) continue;
        (existingBundles[bundleId] ||= []).push(String(item.variant_id));
      }
      return Object.values(existingBundles).some(
        (variantIds) =>
          variantIds.some((id) => selectedVariantIds.includes(id)) &&
          variantIds.some((id) => !selectedVariantIds.includes(id)),
      );
    } catch (error) {
      return false;
    }
  }

  /* DER KAUF. Payload an /cart/add.js, Reihenfolge der Positionen:
       1. Rahmen, Glas, [Jaw, wenn gewaehlt und nicht "None"] — alle mit
          derselben `_customizable_group_id` (Zeitstempel); die Schublade
          fasst sie daran zu einer Zeile zusammen
       2. Zubehoer aus <accessories-component>
       3. Bundle-Teile aus <bundles-component>; deren Properties landen
          zusaetzlich auf der ERSTEN Position (dem Rahmen)
       4. Geschenke
     Form und Reihenfolge sind Teil des Vertrags mit dem Fulfilment
     (docs/cart-payload-diff.md) — nichts davon umstellen.

     Die `try`-Bloecke um die Fremdbauteile sind Absicht: faellt eines aus,
     wird die Brille trotzdem gekauft. */
  async function purchase(e) {
    try {
      if ($("accessories-component")?.needsSelection()) {
        if ($(".popup--accessories")) theme.popupApp.open("accessories");
        e?.preventDefault();
        e?.stopPropagation();
        return;
      }
    } catch (error) {
      // Zubehoer nicht bereit: ohne Auswahlpruefung weiter
    }

    const frameVariantId = frameForm.querySelector(
      "input[type=radio]:checked",
    ).value;
    const lensVariantId = lensForm.querySelector(
      "input[type=radio]:checked",
    ).value;
    const jawVariantId = jawForm?.querySelector(
      "input[type=radio]:checked",
    )?.value;

    const bundleId = Date.now().toString();

    const selectedVariantIds = [frameVariantId, lensVariantId];
    if (
      partsData.jaw &&
      partsData.jaw.variants[Number(jawVariantId)].title !== "None" &&
      jawToggle.checked
    ) {
      selectedVariantIds.push(jawVariantId);
    }

    const items = selectedVariantIds.map((id) => ({
      id,
      quantity: 1,
      properties: { _customizable_group_id: bundleId },
    }));

    try {
      const accessoriesComponent = $("accessories-component");
      if (accessoriesComponent)
        items.push(...accessoriesComponent.getSerializedItems());
    } catch (error) {
      // ohne Zubehoer weiter
    }

    try {
      const bundlesComponent = $("bundles-component");
      if (bundlesComponent) {
        if (!(await bundlesComponent.validateCustomizableSubmit())) return;
        const { items: bundleItems, properties: bundleProperties } =
          bundlesComponent.getSerializedForm();
        items.push(...bundleItems);
        items[0].properties = { ...items[0].properties, ...bundleProperties };
      }
    } catch (error) {
      // ohne Bundle weiter
    }

    try {
      const giftsComponent = $("gifts-component");
      if (giftsComponent) {
        if (!giftsComponent.validateSubmit()) {
          e?.preventDefault();
          e?.stopPropagation();
          return;
        }
        items.push(...giftsComponent.getSerializedItems());
      }
    } catch (error) {
      // ohne Geschenk weiter
    }

    try {
      const response = await fetch("/cart/add.js", {
        headers: { "Content-Type": "application/json" },
        method: "POST",
        body: JSON.stringify({ items }),
      });
      if (response.status !== 200) {
        const data = await response.json();
        alert(data.description);
        return;
      }
    } catch (error) {
      return;
    }

    /* Keine Weiterleitung auf /cart: `nko:cart:add`
       laesst die Schublade (assets/cart-drawer.js) den Warenkorb nachladen
       und auffahren. */
    document.dispatchEvent(
      new CustomEvent("nko:cart:add", {
        bubbles: true,
        composed: true,
        detail: { quelle: "configurator.js" },
      }),
    );

    /* <bundles-component> liest darauf die Warenkorb-Positionen neu und
       zaehlt `_bundleNum` hoch. */
    section.dispatchEvent(new CustomEvent("customizable:added-to-cart"));
  }

  return () => {
    observer.disconnect();
    if (window.CustomizableATC === addToCart) delete window.CustomizableATC;
  };
}

if (!customElements.get("nko-configurator")) {
  customElements.define("nko-configurator", NkoConfigurator);
}

/* NUR ALS MODUL LADEN: <script src="…" type="module">, nie mit `defer` —
   der Modulbereich ist der einzige Gueltigkeitsbereich dieser Datei. */
